import React from 'react';
import PropTypes from 'prop-types';
import InViewComponent from '../../InView';
import DeactivateAccount from '../DeactivateAccount';
import BreachDeactivateInfo from '../BreachDeactivateInfo';
import BreachPlusCancelInfo from '../BreachPlusCancelInfo';
import { CardContent } from '../../ProductPanels/cardContent';

const DeactivationSection = ({
  shouldShowBreachRetentionComponent,
  currentSubscription,
  productDetails,
  availableBreachOffers,
  offers,
}) => {
  const renderDeactivationComponent = () => {
    if (!shouldShowBreachRetentionComponent) {
      return <DeactivateAccount />;
    }

    switch (currentSubscription?.family) {
      case 'breach':
        return <BreachDeactivateInfo />;
      case 'breach_plus': {
        const availableOffers = (productDetails.isBreach ? availableBreachOffers : offers).filter(
          offer => offer.family !== currentSubscription.family
        );

        return (
          <BreachPlusCancelInfo
            offer={{
              ...availableOffers[0],
              ...CardContent.breach,
            }}
          />
        );
      }
      default:
        return <DeactivateAccount />;
    }
  };

  return <InViewComponent label="deactivate_your_account">{renderDeactivationComponent()}</InViewComponent>;
};

DeactivationSection.propTypes = {
  shouldShowBreachRetentionComponent: PropTypes.bool.isRequired,
  currentSubscription: PropTypes.shape({
    family: PropTypes.string,
  }).isRequired,
  productDetails: PropTypes.shape({
    isBreach: PropTypes.bool,
  }).isRequired,
  availableBreachOffers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      family: PropTypes.string.isRequired,
    })
  ).isRequired,
  offers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      family: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default DeactivationSection;
